package com.mgacreative.hotelru.feature.hotel.ui.auth

import androidx.compose.animation.Crossfade
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.mgacreative.hotelru.shared.ui.designsystem.components.HFLoadingState
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun AuthScreenContainer(
    viewModel: AuthViewModel = koinViewModel()
) {
    val currentAuthScreen by viewModel.authNavigator.currentScreen.collectAsState()
    val isLoading by viewModel.isLoading.collectAsState()

    LaunchedEffect(Unit) {
        viewModel.checkActiveSession()
    }

    if (isLoading) {
        Box(
            modifier = Modifier
                .fillMaxSize()
                .background(Color(0xFF090F1E)),
            contentAlignment = Alignment.Center
        ) {
            HFLoadingState()
        }
        return
    }

    Crossfade(targetState = currentAuthScreen) { screen ->
        when (screen) {
            AuthScreenType.LOGIN -> LoginScreen(viewModel)
            AuthScreenType.REGISTER -> RegisterScreen(viewModel)
            AuthScreenType.FORGOT_PASSWORD -> ForgotPasswordScreen(viewModel)
        }
    }
}

